/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from 'react'
interface planRenewalProps {
    listProfile : any;
    currentUser : any ;
}

const PlanRenewalSettings : React.FC<planRenewalProps> = ({listProfile ,currentUser}) => {
  return (
    <div>
           <div className="card mb-3">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                              <h6 className="fw-med mb-0 me-3">
                                Auto renewal for plan&nbsp;
                                <i
                                  className="material-symbols-outlined info-ico me-3"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={`Hello ${
                                    currentUser?.name || "there"
                                  }! Enabling auto-renewal means the subscription renews automatically; disabling it stops automatic renewal.`}
                                  style={{
                                    cursor: "pointer",
                                    position: "relative",
                                    top: "4px",
                                    fontSize: "16px",
                                    width: "20px",
                                    height: "20px",
                                  }}
                                >
                                  info
                                </i>
                              </h6>

                              {listProfile?.isPlanRenewal ? (
                                <span className="text-success bold">
                                  Enabled
                                </span>
                              ) : (
                                <span className="text-danger bold">
                                  Disabled
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
    </div>
  )
}

export default PlanRenewalSettings;
